import ListRole from "../views/ListRole.vue";

export default [
  {
    path: "roles",
    component: ListRole,
  },
];
